import toast from "react-hot-toast";
import {
  UPDATE_REPORTS_USER_LIST,
  UPDATE_REPORTS_POST_LIST,
  UPDATE_REPORTS_POST_LIST_LOADING,
  UPDATE_REPORTS_USER_LIST_LOADING,
  UPDATE_REPORTED_USER_DETAILS,
  UPDATE_REPORTEDBY_USER_LIST,
  UPDATE_REPORTED_POST_DETAILS,
  UPDATE_REPORTEDBY_USER_LIST_FOR_POST,
  UPDATE_REPORTEDBY_USER_LIST_LOADING_FOR_POST,
  UPDATE_REPORTEDBY_USER_LIST_LOADING_FOR_USER,
} from "../../store/actionTypes";
import { ENDPOINTS } from "../../utils/endPoints";
import { createParams } from "../../utils/commonFunctions";
import {
  GET_API_CALL,
  POST_API_CALL,
  PUT_API_CALL,
} from "../../utils/services";

/**
 * @description all actions related to report manager
 * @returns response of Report Manager
 */

/**
 * @description Action for fetching all users that are reported
 * @returns state
 */
export const getAllUserReports = () => {
  return (dispatch, getState) => {
    dispatch({ type: UPDATE_REPORTS_USER_LIST_LOADING });
    const { pageNo, limit, searchKey, sortOrder, sortBy } =
      getState().ReportReducer.user.reportedUsers;
    const type = "user";
    const params = createParams({
      searchKey,
      pageNo,
      limit,
      sortOrder,
      sortBy,
      type,
    });
    GET_API_CALL(ENDPOINTS.REPORTS.REPORTED_LIST, params, (response) => {
      console.log("Reported List Response :", response);
      if (response?.isSuccess) {
        let { data, total, totalPage, limit, pageNo } = response?.data;
        const payload = {
          total,
          totalPage,
          dataList: [...data],
          limit,
          pageNo,
        };
        dispatch({
          type: UPDATE_REPORTS_USER_LIST,
          payload: {
            ...payload,
          },
        });
      }
      dispatch({ type: UPDATE_REPORTS_USER_LIST_LOADING });
    });
  };
};

/**
 * @description Action for fetching user details that are reported
 * @returns state
 */
export const getReportedUserDetails = (id, callback) => {
  return (dispatch) => {
    GET_API_CALL(
      ENDPOINTS.REPORTS.REPORTED_USER_DETAILS,
      `?userId=${id}`,
      (response) => {
        console.log("Reported User Details Response :", response);
        if (response.isSuccess) {
          dispatch({
            type: UPDATE_REPORTED_USER_DETAILS,
            payload: { ...response.data },
          });
          callback(response);
        } else callback({});
      }
    );
  };
};

/**
 * @description Action for fetching all users that are reported a particular user i.e id
 * @returns state
 */
export const getReportedByAllUsersList = (id) => {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_REPORTEDBY_USER_LIST_LOADING_FOR_USER,
    });
    const { pageNo, limit, searchKey, sortOrder, sortBy } =
      getState().ReportReducer.user.reportedByUsers;
    const params = createParams({
      entityId: id,
      searchKey,
      pageNo,
      limit,
      sortBy,
      sortOrder,
    });
    GET_API_CALL(ENDPOINTS.REPORTS.REPORTEDBY_LIST, params, (response) => {
      console.log("Reported By User List Response :", response);
      if (response.isSuccess) {
        const { limit, pageNo, total, totalPage, data } = response.data;
        const payload = {
          limit,
          pageNo,
          total,
          totalPage,
          dataList: data,
        };
        dispatch({
          type: UPDATE_REPORTEDBY_USER_LIST,
          payload: payload,
        });
      }
      dispatch({
        type: UPDATE_REPORTEDBY_USER_LIST_LOADING_FOR_USER,
      });
    });
  };
};

/**
 * @description Action for fetching all Post that are reported
 * @returns state
 */
export const getAllReportedPostList = () => {
  return (dispatch, getState) => {
    dispatch({ type: UPDATE_REPORTS_POST_LIST_LOADING });
    const { pageNo, limit, searchKey, sortOrder, sortBy, isLoading } =
      getState().ReportReducer.post.reportedPost;
    const type = "post";
    const params = createParams({
      searchKey,
      pageNo,
      limit,
      sortOrder,
      sortBy,
      type,
    });
    GET_API_CALL(ENDPOINTS.REPORTS.REPORTED_LIST, params, (response) => {
      console.log("Reported Post List Response :", response);
      if (response?.isSuccess) {
        let { data, total, totalPage, limit, pageNo } = response?.data;
        const payload = {
          total,
          totalPage,
          dataList: [...data],
          limit,
          pageNo,
        };
        dispatch({
          type: UPDATE_REPORTS_POST_LIST,
          payload: {
            ...payload,
          },
        });
      }
      dispatch({ type: UPDATE_REPORTS_POST_LIST_LOADING });
    });
  };
};

/**
 * @description Action for fetching Post details that are reported
 * @returns state
 */
export const getReportedPostDetails = (id, callback) => {
  return (dispatch) => {
    GET_API_CALL(
      ENDPOINTS.REPORTS.REPORTED_POST_DETAILS,
      `?postId=${id}`,
      (response) => {
        console.log("Reported Post Details Response :", response);
        if (response.isSuccess) {
          dispatch({
            type: UPDATE_REPORTED_POST_DETAILS,
            payload: { ...response.data },
          });
        }
        callback();
      }
    );
  };
};

/**
 * @description Action for fetching all users that are reported a particular POST i.e postId
 * @returns state
 */
export const getPostReportedByAllUserList = (id) => {
  return (dispatch, getState) => {
    dispatch({ type: UPDATE_REPORTEDBY_USER_LIST_LOADING_FOR_POST });
    const { pageNo, limit, searchKey, sortOrder, sortBy } =
      getState().ReportReducer.post.reportedByUsers;
    const params = createParams({
      entityId: id,
      searchKey,
      pageNo,
      limit,
      sortBy,
      sortOrder,
    });
    GET_API_CALL(ENDPOINTS.REPORTS.REPORTEDBY_LIST, params, (response) => {
      console.log("Reported By User List Response :", response);
      if (response.isSuccess) {
        const { limit, pageNo, total, totalPage, data } = response.data;
        const payload = {
          limit,
          pageNo,
          total,
          totalPage,
          dataList: data,
        };
        dispatch({
          type: UPDATE_REPORTEDBY_USER_LIST_FOR_POST,
          payload: payload,
        });
      }
      dispatch({ type: UPDATE_REPORTEDBY_USER_LIST_LOADING_FOR_POST });
    });
  };
};

/**
 * @description Action for DELETE POST via postId
 */
export const deleteReportedPost = (postId, callback) => {
  return () => {
    PUT_API_CALL(
      ENDPOINTS.REPORTS.DELETED_REPORTED_POST + `?postId=${postId}`,
      {},
      (response) => {
        console.log("Delete Reported Post Response :", response);
        if (response.isSuccess) {
          toast.success(response.data?.message);
          callback(response);
        } else {
          callback({});
        }
      }
    );
  };
};

/**
 * @description Action for Send Warning email for user or post
 */
export const sendWarningEmail = (data, callback) => {
  return () => {
    const toastId = toast.loading('Sending Email...');
    POST_API_CALL(ENDPOINTS.REPORTS.WARNING_EMAIL, data, (response) => {
      console.log("Warning email Response :", response);
      if (response.isSuccess) {
        toast.success(response.data?.message);
        callback(response);
      } else {
        callback({});
      }
      toast.dismiss(toastId);
    });
  };
};
